import { useState, useEffect } from "react";
import { Button, Input, Modal, Form, Select } from "antd";
import { chargerTypeOptions } from "../../constants/helperConstants";
import EditorComponent from "../../components/EditorComponent";

const AddChargerTypeInBrandModal = (props: any) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const { isModalOpen, brand, onCancel, addChargerType, selectedChargerType, onUpdateChargerType, isEditMode } = props;

  useEffect(() => {
    form.setFieldValue("brand_id", brand?.id);
    form.setFieldValue("brand_name", brand?.name);
    form.setFieldsValue(selectedChargerType);
  }, [selectedChargerType])

  const onFinish = (values: any) => {
    if (Object.keys(selectedChargerType).length === 0) {
      const params = { brandId: brand?.id, chargerTypeData: { charger_type: values } };
      addChargerType(params, setLoading, form);
    } else {
      const params = { brandId: brand?.id, chargerTypeData: { charger_type: values }, id: selectedChargerType?.id };
      onUpdateChargerType(params, setLoading, form);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Modal
      title={isEditMode ? "Update Charger Type" : "Add Charger Type"}
      open={isModalOpen}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      width={1000}
      style={{ top: 0 }}
      footer={false}
    >
      <Form
        name="charger_type_form"
        form={form}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item name="brand_name" label="Brand Name">
          <Input disabled />
        </Form.Item>

        <Form.Item name="charger_size" label="Charger Type">
          <Select
            placeholder="Select charger type"
            showSearch
            optionFilterProp="children"
            options={chargerTypeOptions}
            filterOption={(inputValue, option: any) =>
              option.label.toLowerCase().includes(inputValue.toLowerCase())
            }
          >
          </Select>
        </Form.Item>

        <Form.Item
          label="Seek Payment Email Template"
          name="seek_payment_email_template"
        >
          <EditorComponent />
        </Form.Item>

        <Form.Item
          label="Refund Email Template"
          name="refund_email_template"
        >
          <EditorComponent />
        </Form.Item>

        <Form.Item
          label="Refund Processed Email Template"
          name="refund_processed_email_template"
        >
          <EditorComponent />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button
              type="default"
              onClick={() => {
                form.resetFields();
                onCancel();
              }}
            >
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {isEditMode ? "Update" : "Add"}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddChargerTypeInBrandModal;
